import { Component, Input, OnInit, inject } from '@angular/core';
import { PatientPrescriberNote } from 'app/core/models/patient-prescriber-note.model';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { PatientPrescriberService } from 'app/core/services/patient-prescriber.service';

import { NoteComponent } from '../../../shared/components/note/note.component';
import { SafeHtmlPipe } from '../../../shared/pipes/safe-html.pipe';

@Component({
    selector: 'app-patient-prescriber-active-note',
    templateUrl: './patient-prescriber-active-note.component.html',
    styleUrls: ['./patient-prescriber-active-note.component.scss'],
    imports: [NoteComponent, SafeHtmlPipe]
})
export class PatientPrescriberActiveNoteComponent implements OnInit {
  private patientPrescriberService = inject(PatientPrescriberService);
  private authService = inject(AuthenticationService);

  @Input() patientPrescriberId: number;
  note: PatientPrescriberNote;

  isClientPortal = false;

  ngOnInit() {
    this.patientPrescriberService.note(this.patientPrescriberId).subscribe(note => { this.note = note });
    this.isClientPortal = this.authService.isClientUser;
  }

  public get header() {
    return this.isClientPortal ? 'NOTES FOR TASK FROM R1' : 'NOTES FOR REFERRAL AND CONSULT NOTE TASKS';
  }
}
